import { css } from 'lit';

var css_248z = css`:host{--mainnav-item-theme-color:#5925dc;--mainnav-item-color:#344054;--mainnav-item-borderBottom-width:0.125rem}li{height:100%}a.nav-link{align-items:center;border-bottom:var(--mainnav-item-borderBottom-width) solid transparent;color:var(--mainnav-item-color);display:flex;min-height:100%}a.nav-link.active,a.nav-link:hover{border-color:var(--mainnav-item-theme-color);color:var(--mainnav-item-theme-color)}`;

export { css_248z as default };
//# sourceMappingURL=sgds-mainnav-item2.js.map
